import _objectSpread from "D:\\liveBranch\\PosFrontendLive\\dev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\liveBranch\\PosFrontendLive\\dev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import * as React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var propTypes = {
  'aria-label': PropTypes.string,
  onClick: PropTypes.func,

  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: PropTypes.oneOf(['white'])
};
var defaultProps = {
  'aria-label': 'Close'
};
var CloseButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["className", "variant"]);

  return /*#__PURE__*/_jsx("button", _objectSpread({
    ref: ref,
    type: "button",
    className: classNames('btn-close', variant && "btn-close-".concat(variant), className)
  }, props));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
export default CloseButton;